import moment from 'moment-timezone';

export class ContractPerformanceSavingsBreakdown {
	public date: Date;
	public volumeDisplay: number;
	public supplyRateDisplay: number;
	public supplyCost: number;
	public ptcDisplay: number;
	public utilityCost: number;
	public costAvoidance: number;

	constructor(contractPerformanceSavingsBreakdown?: ContractPerformanceSavingsBreakdown) {
		Object.assign(this, contractPerformanceSavingsBreakdown);

		this.date = this.date ? new Date(moment(this.date).format('MMM DD, YYYY hh:mm:ss a')) : this.date;
	}
}
